type OriginalConfig = {
  slug: string;
  notionWorkName: string;
};

export const ORIGINALS: OriginalConfig[] = [
  { slug: "seeingdouble", notionWorkName: "라온의 남자" },
];

const ORIGINAL_SLUG_SET = new Set(ORIGINALS.map((o) => o.slug));

export function isOriginalSlug(slug: string | undefined): slug is string {
  return typeof slug === "string" && ORIGINAL_SLUG_SET.has(slug);
}

/**
 * @throws ORIGINALS 또는 ipSlugs 에 중복이 있거나, ORIGINALS slug 가 ipSlugs 에 누락되면
 */
export function assertOriginalsParity(ipSlugs: readonly string[]): void {
  const originalSlugs = ORIGINALS.map((o) => o.slug);
  if (new Set(originalSlugs).size !== originalSlugs.length) {
    throw new Error("[originals] ORIGINALS 에 중복 slug 존재");
  }

  const ipSlugSet = new Set(ipSlugs);
  if (ipSlugSet.size !== ipSlugs.length) {
    throw new Error("[originals] ORIGINALS_LIST 에 중복 slug 존재");
  }

  const missing = originalSlugs.filter((s) => !ipSlugSet.has(s));
  if (missing.length > 0) {
    throw new Error(`[originals] ORIGINALS_LIST 에서 누락된 ORIGINALS slug: ${missing.join(", ")}`);
  }
}
